<template>
<div class="sidebar map-sidebar opportunity-detail">
	<a class="sidebar-title" @click="goToOpportunityList()">
		Discover more...
	</a>
	<div class="sidebar-content">
		<hr>
		<grid flat class="brief-detail">
			<grid-item size="1/4">
				<img src="@/assets/images/invest-icons/culture.svg">
			</grid-item>
			<grid-item size="3/4">
				<h5>{{ opportunity.name }}</h5>
				<p>
					<span class="key">Sector:</span>
					<span class="value">{{ opportunity.sector.name }}</span>
				</p>
				<p>
					<span class="key">Region:</span>
					<span class="value">{{ opportunity.region.name }}</span>
				</p>
				<p>
					<span class="key">GPS:</span>
					<span class="value">{{ opportunity.center[0] + ', ' + opportunity.center[1] }}</span>
				</p>
			</grid-item>
		</grid>
		<opportunity-menu
			:opportunity="opportunity"
		/>
		<oil-lic-menu
			v-if="opportunity.sectorId == 30"
		/>
	</div>
	<button-group />
</div>
</template>

<script>
import OpportunityMenu from './OpportunityMenu'
import ButtonGroup from '../../components/ButtonGroup'
import OilLicMenu from './OilLicMenu'

import { mapActions, mapState } from 'vuex'
import { getPointOfInterestType } from '@/utils/helpers'

export default {
	components: {
		OpportunityMenu,
		ButtonGroup,
		OilLicMenu
	},
	computed: {
		...mapState({
			opportunity: ({ OpportunityStore }) => OpportunityStore.opportunity,
			pointOfInterestList: ({ NearbyInfrastructureStore }) => NearbyInfrastructureStore.list
		})
	},
	mounted() {
		this.$root.$emit('removeAllMarkers')
		this.getOpportunity({
			opportunityId: this.$route.params.opportunityId
		}).then(() => {
			this.$root.$emit('createMarker', {
				opportunity: {
					...this.opportunity,
					zoom: 14
				},
				active: true
			})
			this.getPoints(this.opportunity.center).then(() => {
				this.$root.$emit('removeAllPointsOfInterest')
				this.pointOfInterestList.map(place => {
					let type = getPointOfInterestType(place)
					this.$root.$emit('createPointOfInterest', {
						place,
						type,
						opportunity: this.opportunity
					})
				})
			})
			this.$root.$emit('highlightRegions')
		})
	},
	methods: {
		...mapActions({
			getOpportunity: 'OpportunityStore/getOpportunity',
			getPoints: 'NearbyInfrastructureStore/getPoints'
		}),
		goToOpportunityList() {
			this.$router.push({
				name: 'opportunity-list',
				query: {
					...this.$route.query
				}
			})
		}
	}
}
</script>

<style lang="scss">
.opportunity-detail {
	padding-right: 0 !important;
	width: 276px !important;

	.sidebar-title {
		cursor: pointer;
	}
	.title {
		font-weight: 400 !important;
		margin-bottom: 18px !important;
	}
	.sidebar-content {
		overflow-y: auto;
		overflow-x: hidden;
		position: absolute;
		top: 41px;
		bottom: 0px;
		margin-bottom: 105px;
	}

	.sidebar-content::-webkit-scrollbar {
		width: 2px;
	}
	.sidebar-content::-webkit-scrollbar-thumb {
		border: 4px solid rgba(0, 0, 0, 0);
		background-clip: padding-box;
		background-color: #4ba98b;
	}
	hr {
		margin: 14px 0 5px !important;
	}
	.brief-detail {
		p {
			line-height: 14px !important;
		}
	}
}
</style>
